// extracted by mini-css-extract-plugin
export default {"badge":"PlantBadge_badge__cG4w5","vegan":"PlantBadge_vegan__DyPPR","vegetarian":"PlantBadge_vegetarian__Lz423"};